export default "__VITE_ASSET__D$MTBqdk__"